import { OPPORTUNITY_TYPE_IDS } from 'shared'

/**
 * オポ種別IDから名前への変換マップ
 */
export const OPPORTUNITY_TYPE_NAMES: Record<number, string> = {
  [OPPORTUNITY_TYPE_IDS.CAPTAIN]: 'キャプテンオポ',
  [OPPORTUNITY_TYPE_IDS.SALES]: '営業オポ',
}
